"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldMuteByCategory = void 0;
var consent_policy_client_accessor_1 = require("@wix/consent-policy-client-accessor");
var types_1 = require("../types");
var consentPolicyAccessor = new consent_policy_client_accessor_1.ConsentPolicyAccessor();
exports.shouldMuteByCategory = function (category) {
    var policy = consentPolicyAccessor.getCurrentConsentPolicy();
    if (category === types_1.EventCategories.Essential) {
        return false;
    }
    if (category === types_1.EventCategories.Functional ||
        category === types_1.EventCategories.Analytics) {
        return !policy[category];
    }
    return !policy.functional || !policy.analytics;
};
//# sourceMappingURL=consent-policy.js.map